import { type ReactElement, type ReactNode } from 'react'
import { type PermissionDefinition, type PermissionType } from '@terros/common'
import { Accordion } from '@mantine/core'
import { type GroupedPermissionDefinitions } from '@front/model'
import { PermissionDefinitionList } from './PermissionDefinitionList'

type Props = {
  groups: GroupedPermissionDefinitions
  openGroup: string | null
  onChange: (category: string | null) => void
  render: (type: PermissionType, definition: PermissionDefinition) => ReactNode
}

export const PermissionCategoryAccordion = ({ groups, openGroup, onChange, render }: Props): ReactElement => {
  return (
    <Accordion value={openGroup} onChange={onChange}>
      {Array.from(groups.entries()).map(([category, definitions]) => (
        <Accordion.Item key={category} value={category}>
          <Accordion.Control>{category}</Accordion.Control>
          <Accordion.Panel>
            {openGroup === category && <PermissionDefinitionList definitions={definitions} render={render} />}
          </Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion>
  )
}
